import { App } from 'vue'
import { getThemeCls } from '@/utils/theme'

export default {
  install: (app:App) => {
    app.mixin({

      computed: {
        themeCls () {
          return getThemeCls()
        }
      },

      mounted () {
        if (this.$el) {
          this.$el.__vue__ = this
        }
      },

      beforeUnmount () {
        if (this.$el) {
          this.$el.__vue__ = null
        }
      }
    })
  }
}
